/* eslint-disable */
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  Table,
  TableBody,
  TableContainer,
  Paper,
} from "@material-ui/core";
import { templateStrings } from "../../../../Constant";
import { fetchPreviousSettlementsAction } from "../../../../redux/action-creators/settlementActionCreator";
import { Header, Row, Footer } from "./TableComponent";

function PreviousSettlements(props) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [openedId, setOpenedId] = React.useState("");
  const { content, totalItems } = props;
  const templateString = templateStrings.previousSettlemnts;
  const SelectProps = { inputProps: { "aria-label": "rows per page" }, native: true };

  React.useEffect(() => {
    getList();
  }, [page, rowsPerPage]);

  const handleChange = (input, value) => {
    if (input === "pageNo") {
      setPage(value);
    } else if (input === "rowsPerPage") {
      setRowsPerPage(value);
    }
  };

  const getList = () => {
    props.fetchPreviousSettlements({
      pageNo: page,
      pageSize: rowsPerPage,
      operatorFilter: props && props.operatorId,
      cityFilter: props.cityId,
    }, "header");
  };

  const onCollapse = (id) => {
    openedId == id ? setOpenedId("") : setOpenedId(id);
  };

  return (
    <div>
      <Paper>
        <TableContainer className="previous-settlements">
          <Table stickyHeader aria-label="collapsible table">
            <Header templateString={templateString} collapsable />
            <TableBody>
              {content.map((row, idx) => (
                <Row templateString={templateString} row={{ ...row, operatorName: props.operatorName, cityId: props.cityId }} collapseable openedId={openedId} onCollapse={onCollapse} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Footer
          colSpan={6}
          count={totalItems}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[10, 25, 50, 75, 100]}
          page={page}
          SelectProps={SelectProps}
          onChangePage={handleChange}
        />
      </Paper>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    content:
      (state
        && state.Settlement
        && state.Settlement.previousSettlements
        && state.Settlement.previousSettlements.items)
      || [],
    headerLoader: (state && state.loadingBar && state.loadingBar.header),
    cityFilter: state.Cities.selectedCity,
    totalItems:
      (state
        && state.Settlement
        && state.Settlement.previousSettlements
        && state.Settlement.previousSettlements.totalItems)
      || 0,
  };
}

const mapDispatchToProps = (dispatch, state) => ({
  fetchPreviousSettlements: (params, loaderScope) => {
    dispatch(fetchPreviousSettlementsAction(params, loaderScope));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PreviousSettlements));
